exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* App Colors\n------------------------------------------------------------ */\n.title {\n  text-align: center; }\n\n.menu-buttons {\n  text-align: center; }\n\n.menu-button {\n  margin: 1vh 0;\n  padding: 2vh 4vh;\n  color: #000055;\n  font-size: 6vh;\n  line-height: initial; }\n\n.menu-button:hover {\n  color: #3333cc; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/app/admin-area/containers/main-menu-page/main-menu-page.scss
// module id = ../../../../../src/app/admin-area/containers/main-menu-page/main-menu-page.scss
// module chunks = main